module.exports = __webpack_public_path__ + "static/media/app-family-to-family.4caf9331.jpg";